import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {Ng2PaginationModule} from 'ng2-pagination';

import {PaginationBootstrapModule} from 'shared/pagination-bootstrap/pagination-bootstrap.module';
import {SearchBarModule} from 'shared/search-bar/search-bar.module';
import {ApptextsRoutingModule} from './apptexts-routing.module';
import {ApptextsComponent} from './apptexts.component';
import {ApptextsRepository} from './repositories/apptexts.repository';
import {ApptextsService} from './services/apptexts.service';
import { ModalAddTextModule } from './modal-add-text/modal-add-text.module';
import { ModalConfirmationModule } from 'shared/modals/modal-confirmation/modal-confirmation.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    Ng2PaginationModule,
    PaginationBootstrapModule,
    ApptextsRoutingModule,
    SearchBarModule,
    ModalAddTextModule,
    ModalConfirmationModule,
  ],
  declarations: [
    ApptextsComponent,
  ],
  providers: [
    ApptextsService,
    ApptextsRepository,
  ],
})
export class ApptextsModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/apptexts/apptexts.module.ts